import {
  APP_INITIALIZER,
  type EnvironmentProviders,
  makeEnvironmentProviders,
} from '@angular/core';

import type { ITechnicalLogHandler } from './services/handlers/i-technical-log.handler';
import { TechnicalLogHandler } from './services/handlers/technical-log.handler';
import { DocumentUserActivityProvider } from './services/providers/document-user-activity.provider';
import { IndexedDbTechnicalLogStoreProvider } from './services/providers/indexed-db-technical-log-store.provider';
import { PerformanceResourceTimingProvider } from './services/providers/performance-resource-timing.provider';
import {
  RESOURCE_TIMING_PROVIDER,
  TECHNICAL_LOG_HANDLER,
  TECHNICAL_LOG_STORE_PROVIDER,
  USER_ACTIVITY_PROVIDER,
} from './tokens/telemetry.tokens';

/**
 * Registrata nell'injector di radice: il diario e' uno solo per l'applicazione — due istanze terrebbero
 * due buffer, e una segnalazione ne allegherebbe meta' — e comincia a registrare all'avvio, prima della
 * prima rotta, perche' anche cio' che succede sulla porta d'ingresso va spiegato.
 */
export function provideTechnicalLog(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: TECHNICAL_LOG_STORE_PROVIDER, useClass: IndexedDbTechnicalLogStoreProvider },
    { provide: USER_ACTIVITY_PROVIDER, useClass: DocumentUserActivityProvider },
    { provide: RESOURCE_TIMING_PROVIDER, useClass: PerformanceResourceTimingProvider },
    { provide: TECHNICAL_LOG_HANDLER, useClass: TechnicalLogHandler },
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: (handler: ITechnicalLogHandler) => () => handler.start(),
      deps: [TECHNICAL_LOG_HANDLER],
    },
  ]);
}
